export default __webpack_public_path__ + "static/media/TransferThree.1b0cda34.svg";